export const SALES_RETURN_INVOICE_TYPE_TAX = "SALES RETURN TAX INVOICE"
export const SALES_RETURN_INVOICE_TYPE_ESTIMATE = "SALES RETURN ESTIMATE"

export const SALES_RETURN_TYPE_DROPS = [
  { text: SALES_RETURN_INVOICE_TYPE_TAX, value: SALES_RETURN_INVOICE_TYPE_TAX },
  { text: SALES_RETURN_INVOICE_TYPE_ESTIMATE, value: SALES_RETURN_INVOICE_TYPE_ESTIMATE },
]

/** Map legacy/wrong sales labels to sales-return invoice types. */
export function normalizeSalesReturnInvoiceType(value?: string | null): string {
  const raw = (value ?? "").trim()
  const upper = raw.toUpperCase()
  if (upper === "SALES ESTIMATE" || upper === "SALES RETURN ESTIMATE") {
    return SALES_RETURN_INVOICE_TYPE_ESTIMATE
  }
  if (upper === "SALES TAX INVOICE" || upper === "SALES RETURN TAX INVOICE") {
    return SALES_RETURN_INVOICE_TYPE_TAX
  }
  return raw || SALES_RETURN_INVOICE_TYPE_TAX
}
